// Search text for IZTeach `tags_contain` filters, shared by the kho screens that query IZ directly.

// IZ tags are unaccented hyphen-joined title; _contain is plain regex so diacritics don't match; đ hand-mapped like unidecode
export function searchSlug(input: string): string {
  const folded = String(input || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd');
  return folded
    .replace(/[!@%^*()+=<>?/,.:;'"&#[\]~$_`\-{}|\\]/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .join('-');
}
